/**
 * The rule behind the chat composers' brand gate. Pure, so the three composer
 * surfaces (`chat-prompt-input-bar`, `launch-composer`,
 * `canvas-chat-thread`) cannot drift and the rule is testable without a DOM.
 *
 * Submission is gated on the ACTIVE brand being ready (`isActiveBrandReady`):
 * a new chat is scoped to that brand, and generating against a brand that is
 * still extracting has no design system to draw on (the orchestrator would
 * classify the first turn as an extraction run). `hasReadyBrand` only picks
 * the copy: with no ready brand anywhere the org is still in first-brand
 * setup; otherwise the user merely has an in-flight brand selected.
 */

/**
 * Which placeholder the gate puts in the composer. Each caller words it in
 * its own catalog: the product composers read `chat`
 * (`composer.placeholder.<key>`), the marketing home's product demo
 * `productDemo`.
 */
export type ComposerBrandGatePlaceholder =
  | 'default'
  | 'noReadyBrand'
  | 'activeBrandExtracting'

export function getComposerBrandGatePlaceholder(args: {
  isActiveBrandReady: boolean
  hasReadyBrand: boolean
}): ComposerBrandGatePlaceholder {
  if (args.isActiveBrandReady) {
    return 'default'
  }
  return args.hasReadyBrand ? 'activeBrandExtracting' : 'noReadyBrand'
}
